import React, { useEffect } from 'react';
import { Result } from 'antd';
import wgjLogo from '../../../../images/wgjlogo.jpg';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../LicensePrivate/LicenseView.css';

const LicensePublicView = ({ license }) => {
  useEffect(() => {
    document.title = '营业执照查看';
    
    if (license?.name || license?.companyName) {
      document.title = `${license.name || license.companyName} - 营业执照`;
    }
  }, [license]);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    // 如果日期字符串已经包含中文格式，直接返回
    if (dateString.includes('年')) {
      return dateString;
    }
    
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return dateString; // 如果转换失败，返回原始字符串
      }
      return `${date.getFullYear()}年${String(date.getMonth() + 1).padStart(2, '0')}月${String(date.getDate()).padStart(2, '0')}日`;
    } catch (e) {
      console.error('日期格式化失败:', e);
      return dateString;
    }
  };

  // 处理有效期的特殊函数
  const formatValidityPeriod = (validityPeriod) => {
    if (!validityPeriod) return '';

    // 如果包含"至"，取结束日期部分
    if (validityPeriod.includes('至')) {
      const [, endDate] = validityPeriod.split('至');
      return endDate.trim(); // 移除可能的空格
    }

    // 如果是标准日期格式（如：2025-08-01），转换为中文格式
    if (validityPeriod.includes('-')) {
      return formatDate(validityPeriod);
    }

    // 如果已经是中文格式（如：2025年08月01日），直接返回
    return validityPeriod;
  };

  if (!license) {
    return (
      <Result
        status="warning"
        title="未找到营业执照"
        subTitle="请检查您的链接是否正确，或联系管理员获取有效链接。"
      />
    );
  }

  // 适配不同的数据结构
  const licenseData = {
    name: license?.name || license?.companyName || '',
    number: license?.number || license?.creditCode || '',
    address: license?.address || '',
    legalRepresentative: license?.legalRepresentative || license?.legalPerson || '',
    type: license?.type || license?.companyType || '',
    category: license?.category || '',
    registeredCapital: license?.registeredCapital || '',
    usageArea: license?.usageArea || '',
    initialIssueDate: formatDate(license?.initialIssueDate || license?.establishDate || ''),
    validityPeriod: formatValidityPeriod(license?.validityPeriod),
    businessScope: license?.businessScope || '',
    issuingAuthority: license?.issuingAuthority || license?.registrationAuthority || ''
  };
  
  return (
    <div className="bootstrap-license-view">
      {/* Logo区域 */}
      <div className="div_style1" style={{borderTopStyle:'solid', borderTopWidth: '1px', borderTopColor:'gray', zIndex:-1}}>
        <img 
          src={wgjLogo} 
          alt="文化旅游局Logo" 
          height="100px" 
          width="100%"
          onError={(e) => {
            // 如果图片加载失败，显示占位符
            e.target.style.display = 'none';
            const placeholder = e.target.nextSibling;
            if (placeholder) {
              placeholder.style.display = 'block';
            }
          }}
        />
      </div>

      {/* 公司名称 */}
      <div className="div_style1">
        <p></p>
        <span className="font" style={{left:'24px', fontSize:'24px', color:'black', fontWeight:'bold'}}>
          {licenseData.name}
        </span>
        <p></p>
      </div>

      {/* 编号 */}
      <div className="div_style1">
        <p></p>
        <p className="font">
          <span className="glyphicon glyphicon-record" style={{fontSize:'16px', position:'relative', color:'gray'}}></span>
          编号
          <br/>
          <span className="font" style={{left:'22px', fontSize:'20px', color:'black'}}>{licenseData.number}</span>
        </p>
        <p></p>
      </div>

      {/* 名称 */}
      <div className="div_style1">
        <p></p>
        <p className="font">
          <span className="glyphicon glyphicon-record" style={{fontSize:'16px', position:'relative', color:'gray'}}></span>
          名称
          <br/>
          <span className="font" style={{left:'22px', fontSize:'20px', color:'black'}}>{licenseData.name}</span>
        </p>
        <p></p>
      </div>

      {/* 住所 */}
      <div className="div_style1">
        <p></p>
        <p className="font">
          <span className="glyphicon glyphicon-record" style={{fontSize:'16px', position:'relative', color:'gray'}}></span>
          住所
          <br/>
          <span className="font" style={{left:'22px', fontSize:'20px', color:'black'}}>{licenseData.address}</span>
        </p>
        <p></p>
      </div>

      {/* 法定代表人 */}
      <div className="div_style1">
        <p></p>
        <p className="font">
          <span className="glyphicon glyphicon-record" style={{fontSize:'16px', position:'relative', color:'gray'}}></span>
          法定代表人
          <br/>
          <span className="font" style={{left:'22px', fontSize:'20px', color:'black'}}>{licenseData.legalRepresentative}</span>
        </p>
        <p></p>
      </div>

      {/* 主要负责人 */}
      <div className="div_style1">
        <p></p>
        <p className="font">
          <span className="glyphicon glyphicon-record" style={{fontSize:'16px', position:'relative', color:'gray'}}></span>
          主要负责人
          <br/>
          <span className="font" style={{left:'22px', fontSize:'20px', color:'black'}}>{licenseData.legalRepresentative}</span>
        </p>
        <p></p>
      </div>

      {/* 类型 */}
      <div className="div_style1">
        <p></p>
        <p className="font">
          <span className="glyphicon glyphicon-record" style={{fontSize:'16px', position:'relative', color:'gray'}}></span>
          类型
          <br/>
          <span className="font" style={{left:'22px', fontSize:'20px', color:'black'}}>{licenseData.type}</span>
        </p>
        <p></p>
      </div>

      {/* 单位类别 */}
      <div className="div_style1">
        <p></p>
        <p className="font">
          <span className="glyphicon glyphicon-record" style={{fontSize:'16px', position:'relative', color:'gray'}}></span>
          单位类别
          <br/>
          <span className="font" style={{left:'22px', fontSize:'20px', color:'black'}}>{licenseData.category}</span>
        </p>
        <p></p>
      </div>

      {/* 注册资本 */}
      <div className="div_style1">
        <p></p>
        <p className="font">
          <span className="glyphicon glyphicon-record" style={{fontSize:'16px', position:'relative', color:'gray'}}></span>
          注册资本
          <br/>
          <span className="font" style={{left:'22px', fontSize:'20px', color:'black'}}>{licenseData.registeredCapital}</span>
        </p>
        <p></p>
      </div>

      {/* 使用面积 */}
      <div className="div_style1">
        <p></p>
        <p className="font">
          <span className="glyphicon glyphicon-record" style={{fontSize:'16px', position:'relative', color:'gray'}}></span>
          使用面积
          <br/>
          <span className="font" style={{left:'22px', fontSize:'20px', color:'black'}}>{licenseData.usageArea}</span>
        </p>
        <p></p>
      </div>

      {/* 首次发证日期 */}
      <div className="div_style1">
        <p></p>
        <p className="font">
          <span className="glyphicon glyphicon-record" style={{fontSize:'16px', position:'relative', color:'gray'}}></span>
          首次发证日期
          <br/>
          <span className="font" style={{left:'22px', fontSize:'20px', color:'black'}}>{licenseData.initialIssueDate}</span>
        </p>
        <p></p>
      </div>

      {/* 有效期 */}
      <div className="div_style1">
        <p></p>
        <p className="font">
          <span className="glyphicon glyphicon-record" style={{fontSize:'16px', position:'relative', color:'gray'}}></span>
          有效期
          <br/>
          <span className="font" style={{left:'22px', fontSize:'20px', color:'black'}}>{licenseData.validityPeriod}</span>
        </p>
        <p></p>
      </div>

      {/* 经营范围 */}
      <div className="div_style1">
        <p></p>
        <p className="font">
          <span className="glyphicon glyphicon-record" style={{fontSize:'16px', position:'relative', color:'gray'}}></span>
          经营范围
          <br/>
          <span className="font" style={{left:'22px', fontSize:'20px', color:'black'}}>{licenseData.businessScope}</span>
        </p>
        <p></p>
      </div>

      {/* 发证机关 */}
      <div className="div_style1">
        <p></p>
        <p className="font">
          <span className="glyphicon glyphicon-record" style={{fontSize:'16px', position:'relative', color:'gray'}}></span>
          发证机关
          <br/>
          <span className="font" style={{left:'22px', fontSize:'20px', color:'black'}}>{licenseData.issuingAuthority}</span>
        </p>
        <p></p>
      </div>
    </div>
  );
};

export default LicensePublicView; 